/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_NutritionInputs */

const en_fix_nutrition = /** @type {(inputs: Fix_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutrition source`)
};

const de_fix_nutrition = /** @type {(inputs: Fix_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nährwertquelle`)
};

/**
* | output |
* | --- |
* | "Nutrition source" |
*
* @param {Fix_NutritionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_nutrition = /** @type {((inputs?: Fix_NutritionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_NutritionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_nutrition(inputs)
	return en_fix_nutrition(inputs)
});